import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/sds.png'


const _hoisted_1 = { class: "flow-wrapper" }


export default /*@__PURE__*/_defineComponent({
  __name: 'flow',
  setup(__props) {

const getRandomStyles = (index: number) => {
  const randomLeft = Math.random() * 100;
  const randomDuration = Math.random() * 10 + 5;
  const randomDelay = Math.random() * 2;

  return {
    left: `${randomLeft}%`,
    animationDuration: `${randomDuration}s`,
    animationDelay: `${randomDelay}s`,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (index) => {
      return _createElementVNode("img", {
        key: index,
        src: _imports_0,
        class: "image fall-animation",
        style: _normalizeStyle(getRandomStyles(index))
      }, null, 4)
    }), 64))
  ]))
}
}

})